<template>
  <div class="ti d-flex">
  <div class="d-flex-left">
    <erp-tree @node-click="nodeClick"></erp-tree>
  </div>
  <div class="d-flex-right">

    <div style="width: 815px;border: 1.5px solid #000000;margin-top: 50px;margin-left: 50px;">
        <div style="width: 100%;text-align: center;margin-top: 10px;">
          <h2>收费系统资金收入日报表流程</h2>
        </div>
        <div style="width: 810px;padding: 15px;height: 600px;overflow: auto;">
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>提交人</span>
            <el-input class="cdj_input" v-model="dataform.name" placeholder="提交人"></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>提交人部门</span>
            <el-input class="cdj_input"  v-model="dataform.department" placeholder="提交人部门"></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>提交人职位</span>
            <el-input class="cdj_input" v-model="dataform.position" placeholder="提交人职位"></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>房产</span>
            <el-input class="cdj_input" v-model="homeName" placeholder="点击左边树选择房产" :disabled="true"></el-input>
          </div>
          <div class="cdj_margin_span">
            <span><span class="cdj_span">*</span>日结日期</span>
            <div><el-date-picker class="cdj_input" style="width:100%" v-model="date" type="date" placeholder="选择日期"></el-date-picker></div>
            <div style="margin-top:5px;"><el-button  @click="list" size="mini">统计收银日报表</el-button></div>
          </div>
          <div class="cdj_margin_span">
            <span>本日收入货币形态</span>
            <div style="display: flex;flex-wrap: wrap;">
              <div class="pay_margin">
                <div>财到家</div>
                <div><el-input class="cdj_input" v-model="dataform.caidaojia_money" placeholder="财到家"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>刷卡</div>
                <div><el-input class="cdj_input" v-model="dataform.swipe_money" placeholder="刷卡"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>转账</div>
                <div><el-input class="cdj_input" v-model="dataform.transfer_money" placeholder="转账"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>银联代扣</div>
                <div><el-input class="cdj_input" v-model="dataform.union_pay_money" placeholder="银联代扣"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>银联商务</div>
                <div><el-input class="cdj_input" v-model="dataform.union_pay_business_money" placeholder="银联商务"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>现金</div>
                <div><el-input class="cdj_input" v-model="dataform.cash_money" placeholder="现金"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>码上付</div>
                <div><el-input class="cdj_input" v-model="dataform.code_money" placeholder="码上付"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>其它</div>
                <div><el-input class="cdj_input" v-model="dataform.other_money" placeholder="其它"></el-input></div>
              </div>
              <div class="pay_margin" style="margin-top: 5px;">
                <div>合计金额</div>
                <div><el-input class="cdj_input" v-model="dataform.sum_money" placeholder="合计金额"></el-input></div>
              </div>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>库存现金</span>
            <div style="display: flex;flex-wrap: wrap;">
              <div class="pay_margin">
                <div>上日结存</div>
                <div><el-input class="cdj_input" v-model="dataform.yesterday" placeholder="上日结存"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>本日增加</div>
                <div><el-input class="cdj_input" v-model="dataform.today_increase" placeholder="本日增加"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>本日转存</div>
                <div><el-input class="cdj_input" v-model="dataform.today_transfer" placeholder="本日转存"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>本日结存</div>
                <div><el-input class="cdj_input" v-model="dataform.today_knot" placeholder="本日结存"></el-input></div>
              </div>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>本日收入银行实存费</span>
            <div style="display: flex;flex-wrap: wrap;">
              <div class="pay_margin">
                <div>一般户</div>
                <div><el-input class="cdj_input" v-model="dataform.general_household" placeholder="一般户"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>手续费</div>
                <div><el-input class="cdj_input" v-model="dataform.service_charge" placeholder="手续费"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>合计金额</div>
                <div><el-input class="cdj_input" v-model="dataform.sum_bank" placeholder="合计金额"></el-input></div>
              </div>
            </div>
          </div>
          <div class="cdj_margin_span">
            <span>本日已开票款项</span>
            <div style="display: flex;flex-wrap: wrap;">
              <div class="pay_margin">
                <div>实际开票金额</div>
                <div><el-input class="cdj_input" v-model="dataform.bill_money" placeholder="开票金额"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>实际录入金额</div>
                <div><el-input class="cdj_input" v-model="dataform.bill_input" placeholder="录入金额"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>差异</div>
                <div><el-input class="cdj_input" v-model="dataform.bill_discrepancy" placeholder="差异"></el-input></div>
              </div>
              <div class="pay_margin">
                <div>原因</div>
                <div><el-input class="cdj_input" v-model="dataform.bill_cause" style="width:478px;" placeholder="原因"></el-input></div>
              </div>
            </div>

          </div>
          <div class="cdj_margin_span">
            <span>备注</span>
            <el-input class="cdj_input" type="textarea" v-model="dataform.remarks" :rows="3" placeholder="备注"></el-input>
          </div>
        </div>
        <div style="margin-bottom: 30px;">
          <div style="margin-top:20px;margin-left:700px;"><el-button @click="submit">提交流程</el-button></div>
        </div>
      </div>
  </div>

  </div>
</template>

<script>
import ErpTree from "../Common/erp-tree";
import imgurl from "../../../assets/js/imgurl.js"
export default {
  name: "OrderDailyFlow",
  components: {ErpTree},
  data () {
    return {
      date:'',
      options:'',
      pid:'',
      homeName:'',
      dataform:{
        pindex_id:'',
        name:'',
        department:'',
        position:'',
        house:'',
        rijie_date:'',
        caidaojia_money:'',
        swipe_money:'',
        transfer_money:'',
        union_pay_money:'',
        union_pay_business_money:'',
        cash_money:'',
        code_money:'',
        other_money:'',
        sum_money:'',
        yesterday:'',
        today_increase:'',
        today_transfer:'',
        today_knot:'',
        general_household:'',
        service_charge:'',
        sum_bank:'',
        bill_money:'',
        bill_input:'',
        bill_discrepancy:'',
        bill_cause:'',
        remarks:''
      }
    }
  },
  //界面没出来前加载
  created() {
  },
  // 加载数据
  mounted(){
    //项目列表
    this.$myhttp.get('admin/common/pindex',{
      'Content-Type': 'application/json'
      }).then(backdata=>{
        this.options = backdata.data.data;
    });
  },
  //事件
  methods: {
    //点击树
    nodeClick(data){
      let tree_str=data.tree.map(ret=>{return ret.name}).join('->');
      this.pid = data.tree[0].id;
      this.homeName=tree_str;
    },
    //提交流程
    submit(){
      this.dataform.house = this.homeName;
      let d = this.date;//开始时间
      let date = new Date(d).getTime()/1000;
      this.dataform.rijie_date = date;
      this.dataform.pindex_id = this.pid;

      if(this.dataform.name == ""){
        this.$Message.error('提交人不能为空');
        return false;
      }
      if(this.dataform.department == ""){
        this.$Message.error('提交人部门不能为空');
        return false;
      }
      if(this.dataform.position == ""){
        this.$Message.error('职位不能为空');
        return false;
      }
      if(this.dataform.house == ""){
        this.$Message.error('房产不能为空');
        return false;
      }
      if(this.dataform.rijie_date == "" || this.dataform.rijie_date == null || this.dataform.rijie_date == NaN){
        this.$Message.error('日结日期不能为空');
        return false;
      }
      this.$myhttp.post('admin/OrderDailyList/flow',this.dataform,{
        'Content-Type': 'application/x-www-form-urlencoded'
        }).then(backdata=>{ // 异步执行成功后
          if(backdata.data.code == 201){
            this.$Message.error('日结日期不能为空');
            return false;
          }
          this.dataform={
            pindex_id:'',
            name:'',
            department:'',
            position:'',
            house:'',
            rijie_date:'',
            caidaojia_money:'',
            swipe_money:'',
            transfer_money:'',
            union_pay_money:'',
            union_pay_business_money:'',
            cash_money:'',
            code_money:'',
            other_money:'',
            sum_money:'',
            yesterday:'',
            today_increase:'',
            today_transfer:'',
            today_knot:'',
            general_household:'',
            service_charge:'',
            sum_bank:'',
            bill_money:'',
            bill_input:'',
            bill_discrepancy:'',
            bill_cause:'',
            remarks:''
          };
          this.pid = '';
          this.homeName= '';
          this.date = '';
          this.$Message.success('提交成功');
      });
    },
    //跳转收银日报表
    list(){
      if(this.pid == "" || this.pid == null){
        this.$Message.error('点击左边树选择房产');
        return false;
      }
      if(this.date == '' || this.date ==null){
        this.$Message.error('选择日结日期');
        return false;
      }
      let d = this.date;//开始时间
      let date = new Date(d).getTime()/1000;
      let da = this.dades(date);
      let urls = "/#/OrderDaily/list?pid="+this.pid+'&homeName='+this.homeName+'&date='+da;
      window.open(urls, '_blank');
    },
    //时间戳转日期
    dades(value){
      let date = new Date(parseInt(value) * 1000);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      let second = date.getSeconds();
      minute = minute < 10 ? "0" + minute : minute;
      second = second < 10 ? "0" + second : second;
      return y + '-' + m + '-' + d;
    }
  },
  watch: {
    
  },
  computed:{
    __TABLE_HEIGHT__(){
      return ERP.getStore().__TABLE_HEIGHT__
    }
  },
}
</script>
<style>
  .el-input.is-disabled .el-input__inner {
      background-color: #F5F7FA;
      border-color: #E4E7ED;
      color: #3e3f42 !important;
      cursor: not-allowed;
  }
</style>

<style lang="scss" scoped>
  .ti{
    margin: 1%;
    width: 98%;
  }
  .pay_margin{
    margin-left: 3px;
    width: 92px;
  }
  .d-flex {
    display: flex;
  }
  .d-flex-left {
    margin-right: 10px;
    border-right: 1px solid #eee;
    padding-right: 10px;
  }

  .d-flex-right {
    flex: 1;
  }

</style>



// WEBPACK FOOTER //
// src/components/Admin/OrderDaily/Flow.vue